export const stopPropagation = (event: React.MouseEvent<HTMLDivElement>) => event.stopPropagation();
